module.exports = __webpack_public_path__ + "1b7a2eed001a3f7fd45e24dcab1845d7.svg";